import Http from "./http";

export const addProductFeaturesAPI = (data, options) => {
  return Http.post("admin/product/addProductFeature", data, options);
};
